export function adaptSideNavStructure (navItems) {
  if (!Array.isArray(navItems)) {
    return []
  }

  return navItems.flatMap(item => {
    // If this is a section, transform it into a subtitle + items format
    if (item && item.sectionName && Array.isArray(item.options)) {
      return [
        // First add the section name as a subtitle
        {
          name: item.sectionName,
          type: 'subTitle'
        },
        // Then add all the options
        ...item.options
      ]
    }
    // If the item has children, recursively adapt them
    if (item && Array.isArray(item.children)) {
      return {
        ...item,
        children: adaptSideNavStructure(item.children)
      }
    }
    // Otherwise, return the item as is
    return item
  })
}

export function adaptSideNavSettings (sideNavSettings) {
  if (!sideNavSettings) {
    return { body: [], footer: [] }
  }

  return {
    body: adaptSideNavStructure(sideNavSettings.body),
    footer: adaptSideNavStructure(sideNavSettings.footer)
  }
}
